import React, { Component } from 'react';
import '../App.css';
import {Alert, ToggleButtonGroup, ToggleButton, Button, Well, Glyphicon, ProgressBar, Tabs, Tab, Panel, PanelGroup} from 'react-bootstrap';
import { StickyContainer, Sticky} from 'react-sticky';
import * as jsPDF from 'jspdf';



class Appmain extends Component {
constructor(props) {
super(props);
this.state = {
};

}


render() {
return (
<div className="App">
<div style={{textAlign: "left"}}>
<span>Thank you for your interest in Orthotoolkit! We appreciate hearing your comments, suggestions, and questions. We use this information to improve your experience. Additionally, if there is tool that you would like added to the website, please let us know.</span>
<p/>
<span >The best way to contact us is via email (</span><a href="mailto:orthotoolkit@gmail.com"><span>orthotoolkit@gmail.com</span></a><span>). We strive to read and address all communications!</span>
</div>
</div>
);
}
}
export default Appmain;



// WEBPACK FOOTER //
// ./src/Components/Appmain.js